import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from '@material-ui/core/Paper'
import Header from './Header'
import Snackbar from '@material-ui/core/Snackbar'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import PaymentRequest from './PaymentRequest'
import PaymentDetails from './PaymentDetails'
import CostCenterDetails from './CostCenterDetails'
import PreviewAndCalculations from './PreviewAndCalculations'
import token from '../config/jwt_token'
import { browserHistory } from 'react-router'
import { Backdrop, Button, CircularProgress } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { rejectPaymentRequest } from '../utils/PaymentRequestApiUtils';
import { TextField } from 'material-ui';

function getSteps() {
  return ['Payment Details 1/2', 'Payment Details 2/2', 'Cost Center Details', 'Preview & Calculations'];
}
class VendorBasicDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeStep: 0,
      open: true,
      snackText: '',
      snackOpen: false,
      paymentDetails: undefined,
      bankDetails: undefined,
      cost_center_entries: undefined,
      advance_paid: 0,
      status: 'onboard',
      paymentType: '',
      comment: '',
      rejectDialogBox: false,
      rejectDialogBoxText: '',
      dialogBox: false,
      dialogBoxText: '',
      backDrop: false
    }
    if (token && token.role !== 'City Finance' && token.role !== 'root') {
      browserHistory.push('/home')
    }
  }
  removeTdsRateCheck = () => {
    /*
    This function is used to remove the tds_rate from local storage which is been used
    to check whether the tds rate is changed or not.

    If changed then the tds_rate would be maintain by the code

    If tds_rate is undefined(i.e not preset in local storage) then the tds_rate would be fetch from database and will get inject in the code.

    If tds_rate is false in local storage then it means that the tds_rate is set by injecting the tds_rate from database.

    If tds_rate is true in local storage then it means that the tds_rate is changes by the user and we'll maintain it untill the user updates the payment request (i.e `Sent Changes for approval`) or reloads the page, or used `Clear` button in `PaymentDetails` component.
    */
    let tds_rate = localStorage.getItem('tds_rate');
    if(tds_rate) localStorage.removeItem('tds_rate');
  }
  componentDidMount(props) {
    if (this.props.location && this.props.location.state) {
      this.props.location.state.editData.payment_request.date_of_invoice = new Date(this.props.location.state.editData.payment_request.date_of_invoice)
      this.props.location.state.editData.payment_request.expenditure_start_date = this.props.location.state.editData.payment_request.expenditure_start_date ? new Date(this.props.location.state.editData.payment_request.expenditure_start_date) : null
      this.props.location.state.editData.payment_request.expenditure_end_date = this.props.location.state.editData.payment_request.expenditure_end_date ? new Date(this.props.location.state.editData.payment_request.expenditure_end_date) : null
      this.props.location.state.editData.payment_request.expenditure_month = this.props.location.state.editData.payment_request.expenditure_month.split(',')
      this.props.location.state.editData.cost_center_entries.gst_type = this.props.location.state.editData.payment_request.gst_type
      this.props.location.state.editData.cost_center_entries.gst_avail_type = this.props.location.state.editData.payment_request.gst_avail_type
      this.props.location.state.editData.cost_center_entries.is_recoverable = this.props.location.state.editData.payment_request.is_recoverable === 0 ? false : true
      this.props.location.state.editData.cost_center_entries.amount_recoverable = this.props.location.state.editData.payment_request.amount_recoverable
      this.props.location.state.editData.cost_center_entries.as_per_agreement = this.props.location.state.editData.payment_request.as_per_agreement === 0 ? false : true
      this.props.location.state.editData.cost_center_entries.recoverable_amount_remarks = this.props.location.state.editData.payment_request.recoverable_amount_remarks
      this.setState({
        paymentDetails: this.props.location.state.editData.payment_request,
        paymentType: this.props.location.state.editData.payment_request.type_of_payment,
        cost_center_entries: this.props.location.state.editData.cost_center_entries, 
        status: 'edit',
        comment: this.props.location.state.editData.payment_request.centralFinanceComments
      })
    }
    this.removeTdsRateCheck();
  }
  getPaymentType = (type) => {
    this.setState({ paymentType: type })
  }
  toggleBackdrop = (val) => {
    this.setState({ backDrop: val })
  }
  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <PaymentDetails 
              data={{ 
                paymentDetails: this.state.paymentDetails, 
                status: this.state.status 
              }}
              handleNext={this.handleBankDetails.bind(this)} 
              handleClear={this.handleClear1.bind(this)} 
              getPaymentType={this.getPaymentType} 
              removeTdsRateCheck={this.removeTdsRateCheck} 
              toggleBackdrop={this.toggleBackdrop}
            />
          </div>
        );
      case 1:
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <PaymentRequest 
              data={{ 
                paymentDetails: this.state.paymentDetails, 
                status: this.state.status, 
                paymentType: this.state.paymentType 
              }}
              handleNext={this.handleNext1.bind(this)} 
              handleClear={this.handleClear2.bind(this)} 
              toggleBackdrop={this.toggleBackdrop}
            />
          </div>
        );
      case 2:
        return (
          <CostCenterDetails 
            data={{ 
              cost_center_entries: this.state.cost_center_entries, 
              status: this.state.status, 
              paymentDetails: this.state.paymentDetails 
            }} 
            handleNext={this.handleNext2.bind(this)}
            handleClear={this.handleClear3.bind(this)} 
            handleBack={this.handleBack1.bind(this)} removeTdsRateCheck={this.removeTdsRateCheck}
            toggleBackdrop={this.toggleBackdrop}
          />
        )
      case 3:
        return (
          <PreviewAndCalculations 
            data={{
              paymentDetails: this.state.paymentDetails,
              cost_center_entries: this.state.cost_center_entries, status: this.state.status, advance_paid: this.state.paymentDetails.advance_paid
            }}
            handleClose={this.handleClose.bind(this)} handleBack={this.handleBack2.bind(this)} removeTdsRateCheck={this.removeTdsRateCheck}
            toggleBackdrop={this.toggleBackdrop}
          />
        )
      default: return
    }

  }
  handleClose() {
    this.setState({ activeStep: 0, paymentDetails: undefined, cost_center_entries: undefined })
    if (this.state.status === 'edit') {
      browserHistory.goBack()
    }
  }
  handleBankDetails = (value) => {
    this.setState({ paymentDetails: value, activeStep: this.state.activeStep + 1, bankDetails: value })
  }
  handleNext1 = (value) => {
    if (this.state.activeStep === 1)
      this.setState({ paymentDetails: { ...this.state.paymentDetails, ...value }, activeStep: this.state.activeStep + 1 })

  }
  handleNext2 = (value) => {
    if (this.state.activeStep === 2)
      this.setState({ cost_center_entries: value, activeStep: this.state.activeStep + 1 })

  }
  handleClear1 = () => {
    this.setState({ paymentDetails: undefined, bankDetails: undefined })
  }
  handleClear2 = () => {
    this.setState({
      paymentDetails:
      {
        ...this.state.bankDetails,
        date_of_invoice: null,
        tds_liability: '',
        it_section_applicable: '',
        expenditure_month: [],
        bill_availability: '',
        mode_of_payment: '',
        narration: '',
        invoice_soft_copy_link: '',
        supporting_document_link: '',
        po_number: null,
        invoice_number: this.state.status === 'edit' ? this.state.bankDetails.invoice_number : '',
      }
    })
  }
  handleClear3 = () => {
    this.setState({ cost_center_entries: undefined })
  }

  handleRejectDialogBox = () => {
    this.setState({
      rejectDialogBox: true,
      rejectDialogBoxText: 'Are you sure you want to reject this payment request?'
    })
  }

  HandleComment = (event) => {
    this.setState({ comment: event.target.value })
  }

  handleReject = async () => {
    this.setState({ rejectDialogBox: false })
    let body = JSON.stringify([{
      payment_request_transaction_log_id: this.state.paymentDetails.payment_request_transaction_log_id,
      action: 'reject',
      remarks: this.state.comment
    }])
    rejectPaymentRequest(body).then(response => {
      if (response) {
        if (response.status === 'success') {
          this.setState({ dialogBox: true, dialogBoxText: response.message })
        }
        else {
          this.setState({ snackMessage: response.message, snackOpen: true })
        }
      }
    })
  }

  handleBack1 = (value) => {
    this.setState({ cost_center_entries: value, activeStep: this.state.activeStep - 1 });
  }
  handleBack2 = (value) => {
    this.setState({ advance_paid: value, activeStep: this.state.activeStep - 1 });
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleDialogbox() {
    this.setState({
      status: false,
      activeStep: 0
    })
  }
  handleStepper(index, event) {
    // if (index > this.state.activeStep) {
    //     if (index === 1)
    //         this.handleNext()
    //     if (index === 2)
    //         this.handleContinue()
    // }
    if (index < this.state.activeStep) {
      this.setState({ activeStep: index })
    }
  }

  render() {
    const steps = getSteps();
    const { activeStep } = this.state;
    return (
      <MuiThemeProvider>
        <Backdrop 
          open={this.state.backDrop} 
          style={{ 
            backdropFilter: 'blur(5px)',
            zIndex: this.state.backDrop ? 99999 : -1 
          }} 
        />
        {this.state.backDrop &&  (
          <CircularProgress 
            style={{ 
              color: '#fff',
              position: 'absolute',
              zIndex: '99999',
              left: '50%',
              top: '50%' 
            }} 
          />
        )}
          <Header />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Paper style={{ width: '95%', height: 'auto', marginTop: '20px' }} elevation={1}>
              <Stepper activeStep={activeStep} nonLinear alternativeLabel>
                {steps.map((label, index) => {
                  return (
                    <Step style={{ cursor: 'pointer' }} key={label}>
                      <StepButton
                        onClick={this.handleStepper.bind(this, index)} >
                        {label}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>
              <div style={{ marginLeft: '68px' }}>
                {this.getStepContent(activeStep)}
              </div>
            </Paper>
            <Snackbar
              open={this.state.snackOpen}
              autoHideDuration={1000}
              onClose={this.handleCloseSnack.bind(this)}
              message={this.state.snackText}
            />
          </div>
          {this.state.status !== 'onboard' && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '20px 0px 10px 68px',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <div>
                <TextField
                  onChange={(e) => this.HandleComment(e)}
                  defaultValue={this.state.comment}
                  label="Comments"
                  placeholder="Comments for rejection"
                  margin='normal'
                  style={{ width: '520px' }}
                />
              </div>
              <div>
                <Button
                  variant="contained"
                  size="large"
                  style={{
                    backgroundColor: 'rgb(220,20,60)',
                    color: 'white',
                    marginTop: '10px',
                  }}
                  onClick={this.handleRejectDialogBox.bind(this)}
                >
                  Reject
                </Button>
              </div>
            </div>
          )}
          <Dialog
            open={this.state.rejectDialogBox}
            onClose={() => this.setState({ rejectDialogBox: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.rejectDialogBoxText}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ rejectDialogBox: false })} color="primary">
                No
              </Button>
              <Button onClick={this.handleReject} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.dialogBox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.dialogBoxText}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({ dialogBox: false })
                  browserHistory.goBack()
                }}
                color="primary" autoFocus
              >
              Go back
              </Button>
            </DialogActions>
          </Dialog>
      </MuiThemeProvider>
    )
  }
}
export default VendorBasicDetails


// WEBPACK FOOTER //
// ./src/components/PaymentRequestOnboard.js